module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrap"
  }, [_c('section', {
    staticClass: "section section-white view-warp"
  }, [_c('draggable', {
    staticClass: "components-view",
    attrs: {
      "options": _vm.dragIssuesOptions
    },
    on: {
      "start": _vm.onStart,
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.initData),
      callback: function($$v) {
        _vm.initData = $$v
      },
      expression: "initData"
    }
  }, _vm._l((_vm.initData), function(item, index) {
    return _c('div', {
      staticClass: "component-control"
    }, [(item.name === 'coupon') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-tag"
      }
    })]), _vm._v("\n          优惠券\n        ")] : _vm._e(), _vm._v(" "), (item.name === 'goodsGrid') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-grid"
      }
    })]), _vm._v("\n          商品栅格\n        ")] : _vm._e(), _vm._v(" "), (item.name === 'goodsScroll') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-scroll"
      }
    })]), _vm._v("\n          商品滚动\n        ")] : _vm._e(), _vm._v(" "), (item.name === 'imgHotzone') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-hotzone"
      }
    })]), _vm._v("\n          热区图\n        ")] : _vm._e(), _vm._v(" "), (item.name === 'marquees') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-marquees"
      }
    })]), _vm._v("\n          文字轮播\n        ")] : _vm._e(), _vm._v(" "), (item.name === 'navigation') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-navigation"
      }
    })]), _vm._v("\n          图片导航\n        ")] : _vm._e(), _vm._v(" "), (item.name === 'search') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-search"
      }
    })]), _vm._v("\n          搜索\n        ")] : _vm._e(), _vm._v(" "), (item.name === 'showcase') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-showcase"
      }
    })]), _vm._v("\n          橱窗\n        ")] : _vm._e(), _vm._v(" "), (item.name === 'slider') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-slider"
      }
    })]), _vm._v("\n          轮播\n        ")] : _vm._e(), _vm._v(" "), (item.name === 'special') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-hotzone"
      }
    })]), _vm._v("\n          专题配置\n        ")] : _vm._e()], 2)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "template-view"
  }, [_c('div', {
    staticClass: "template"
  }, [_c('div', {
    staticClass: "template-header"
  }, [_c('div', {
    staticClass: "template-title",
    style: ('background: #fff url(' + _vm.headerBg + ') no-repeat bottom; background-size: 100% auto;')
  }, [_c('span', [_vm._v("标题")])])]), _vm._v(" "), _c('draggable', {
    staticClass: "components-wrap",
    attrs: {
      "options": _vm.dragViewOptions
    },
    on: {
      "start": _vm.onStart,
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.components),
      callback: function($$v) {
        _vm.components = $$v
      },
      expression: "components"
    }
  }, _vm._l((_vm.components), function(item, index) {
    return _c('div', {
      staticClass: "component-item",
      on: {
        "click": function($event) {
          return _vm.setCurrent(index)
        }
      }
    }, [_c('transition', {
      attrs: {
        "name": "el-fade-in-linear"
      }
    }, [(_vm.editorIndex === index) ? _c('div', {
      staticClass: "iconfont icon-trash-alt",
      on: {
        "click": _vm.removeCurrent
      }
    }) : _vm._e()]), _vm._v(" "), (item.name === 'coupon') ? _c('coupon', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'goodsGrid') ? _c('goodsGrid', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'goodsScroll') ? _c('goodsScroll', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'imgHotzone') ? _c('imgHotzone', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'marquees') ? _c('marquees', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'navigation') ? _c('navigation', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'search') ? _c('search', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'showcase') ? _c('showcase', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'slider') ? _c('slider', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'special') ? _c('special', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e()], 1)
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "setting-view"
  }, [(_vm.editorIndex === null) ? _c('div', {
    staticClass: "view-placeholder"
  }, [_c('i', {
    staticClass: "iconfont icon-shapes"
  }), _vm._v("\n        请拖选左侧挂件\n      ")]) : _vm._e(), _vm._v(" "), _c('couponEditor', {
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindCoupons": _vm.showCoupons,
      "bindImgs": _vm.showImgs,
      "bindSort": _vm.showSorts
    }
  }), _vm._v(" "), _c('goodsGridEditor', {
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindGoods": _vm.showGoods
    }
  }), _vm._v(" "), _c('goodsScrollEditor', {
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindGoods": _vm.showGoods
    }
  }), _vm._v(" "), _c('imgHotzoneEditor', {
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindImgs": _vm.showImgs,
      "bindLinks": _vm.showLinks
    }
  }), _vm._v(" "), _c('marqueesEditor', {
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "change": _vm.updataArticle
    }
  }), _vm._v(" "), _c('navigationEditor', {
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindImgs": _vm.showImgs,
      "bindLinks": _vm.showLinks,
      "bindSort": _vm.showSorts
    }
  }), _vm._v(" "), _c('searchEditor', {
    attrs: {
      "res": _vm.editorData
    }
  }), _vm._v(" "), _c('showcaseEditor', {
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindImgs": _vm.showImgs,
      "bindLinks": _vm.showLinks
    }
  }), _vm._v(" "), _c('sliderEditor', {
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindImgs": _vm.showImgs,
      "bindLinks": _vm.showLinks,
      "bindSort": _vm.showSorts
    }
  }), _vm._v(" "), _c('specialEditor', {
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindImgs": _vm.showImgs
    }
  })], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "btn-save",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveConfig
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgsVisible,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeimgsVisible
    }
  }), _vm._v(" "), _c('linkSetter', {
    attrs: {
      "visible": _vm.linksVisible,
      "template_name": _vm.template_name
    },
    on: {
      "setLink": _vm.setLink,
      "closeDialog": _vm.closeDialog
    }
  }), _vm._v(" "), _c('goodsSelect', {
    attrs: {
      "items-visible": _vm.goodsVisible,
      "get-status": _vm.setItemStatus,
      "rel-items-ids": _vm.relItemsIds
    },
    on: {
      "chooseStore": _vm.pickGoods,
      "closeStoreDialog": _vm.closeDialog
    }
  }), _vm._v(" "), _c('couponPicker', {
    attrs: {
      "visible": _vm.couponsVisible
    },
    on: {
      "pickCoupon": _vm.pickCoupon,
      "closeDialog": _vm.closeDialog
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-24c520ab", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24c520ab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/function/shopDecoration.vue
// module id = 2543
// module chunks = 0